import { render, staticRenderFns } from "./ruleList.vue?vue&type=template&id=0c8d9111&scoped=true&"
import script from "./ruleList.vue?vue&type=script&lang=js&"
export * from "./ruleList.vue?vue&type=script&lang=js&"
import style0 from "./ruleList.vue?vue&type=style&index=0&id=0c8d9111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d9111",
  null
  
)

component.options.__file = "ruleList.vue"
export default component.exports